import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-textcounter', 'remaining', 'rakstzīmes');
Labels.set(
    'ui-textcounter',
    'invalid',
    'Lūdzu, ievadiet ne vairāk kā %d rakstzīmes.'
);
